import { Heading, usePublicPagePopupsContext } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import DemoImage from "../DemoImage";
import Form from "../Form";
import { DemonstrationMenu } from "../interfaces";
import {
  Container,
  ImageContainer,
  OpenContentContainer,
  StyledCloseIcon,
  StyledContentContainer,
  StyledLogo,
  TopContainer,
} from "./styles";

const MediumDevicesDemonstration: React.FC<DemonstrationMenu> = ({
  isOpen,
  toggle,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { popupsHeight, animationDuration, isSmallVersion } =
    usePublicPagePopupsContext();

  return (
    <Container
      isOpen={isOpen}
      popupsHeight={popupsHeight}
      extraPaddingTopAnimationDuration={animationDuration}
      isSmallPaddingAnimationVersion={isSmallVersion}
    >
      <TopContainer onClick={toggle} className="closed-content">
        <Heading variant="h7">{t("9248") /* Demonstração! */}</Heading>
        <DemoImage isOpen={isOpen} />
      </TopContainer>
      <OpenContentContainer className="open-content">
        <StyledContentContainer>
          <ImageContainer>
            <DemoImage isOpen={isOpen} />
          </ImageContainer>
          <Form onSuccess={toggle} />
        </StyledContentContainer>
        <StyledLogo />
        <StyledCloseIcon
          fill={theme.colors.secondary}
          onClick={toggle}
          width="20"
        />
      </OpenContentContainer>
    </Container>
  );
};

export default MediumDevicesDemonstration;
